import { ContextType, PureComponent } from "react";
import { Layer, Source } from "react-map-gl/mapbox-legacy";
import { textHaloColor } from "common-client/utils/mapLayers";
import { colors } from "../../../stitches.config";
import { LayerContext } from ".";
import { FIRM } from "./firm";

export const group = "baseFloodElevations";

class MapLayer extends PureComponent<{ firm: FIRM }> {
  declare context: ContextType<typeof LayerContext>;
  render() {
    const { isLayerVisible } = this.context;
    const { firm } = this.props;

    const tiles = [
      `${window.env.APPLICATION_URL}/api/tiles/baseFloodElevations/${firm.id}/{z}/{x}/{y}`,
    ];

    const id = `${group}-${firm.id}`;

    return (
      <Source id={id} tiles={tiles} type="vector">
        <Layer
          id={`${id}-lines`}
          type="line"
          source-layer="src"
          layout={{
            visibility: isLayerVisible({ group, id: firm.id })
              ? "visible"
              : "none",
          }}
          filter={["step", ["zoom"], false, 10, true]}
          paint={{
            "line-width": 10,
            "line-pattern": "bfe-line",
          }}
        />
        <Layer
          id={`${id}-labels`}
          type="symbol"
          source-layer="src"
          layout={{
            "symbol-placement": "line-center",
            visibility: isLayerVisible({ group, id: firm.id })
              ? "visible"
              : "none",
            "text-field": ["get", "elevation"],
            "text-padding": 10,
            "text-max-width": 15,
            "text-size": 15,
            "text-font": ["DIN Offc Pro Bold", "Arial Unicode MS Regular"],
          }}
          filter={["step", ["zoom"], false, 12, true]}
          paint={{
            "text-color": colors.contentPrimaryInverted.value,
            "text-halo-color": textHaloColor,
            "text-opacity": 1,
            "text-halo-width": 1,
          }}
        />
      </Source>
    );
  }
}

MapLayer.contextType = LayerContext;

export default MapLayer;
